<template>
    <div class="link-tab t-a-c">
        <a class="d-i-b" v-for="(item,index) in info.list" :key="index" @click="clickLink(item)">
            <img :src="item.url" alt="">
        </a>
        <transition name="fade">
            <alert :info="popInfo" v-if="showQrPopup" @closePop="closePop"></alert>
        </transition>
        <transition name="fade">
            <div class="alert-wrap p-f" v-show="showPopup" @click="closeAlertPop">
                <div class="alert p-a" :style="{backgroundImage:'url('+popInfo.pop_bg+')'}">
                    <h1>{{alertText}}</h1>
                </div>
            </div>
        </transition>
    </div>
</template>
<style lang="less">
    .link-tab {
        font-size: 0;
        margin-bottom: .933333rem;
        a {
            width: 2.4rem;
            height: 2.88rem;
            margin-left: .02rem;
            cursor: pointer;
            &:nth-child(1) {
                margin-left: 0;
            }
        }
        .popup {
            padding: 1rem;
            .pop-content {
                width: 3.44rem;
                height: 3.44rem;
                margin: .5rem 0;
            }
        }
    }
    .alert-wrap {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .7);
        top: 0;
        left: 0;
        z-index: 3;
        .alert {
            width: 7rem;
            height: 3.44rem;
            top: 50%;
            left: 50%;
            margin: -1.72rem 0 0 -3.5rem;
            background-size: 100% 100%;
            h1 {
                line-height: 3.44rem;
                color: #ffffff;
                text-align: center;
                font-size: .45rem;
            }
        }
    }
</style>

<script>
    import alert from '@components/common/alert/index'
    import Util from "@util/index.js";
    export default {
        components: {
            alert
        },
        props: ['info', 'lan'],
        data() {
            return {
                showQrPopup: false,
                showPopup: false,
                alertText: ''
            }
        },
        computed: {
            popInfo() {
                return {
                    pop_bg: this.info.pop_bg,
                    text_o: this.info.text_o,
                    text_s: this.info.text_s,
                    content: this.info.qrCode,
                    text_t: this.info.text_t,
                    text_f: this.info.text_f
                }
            }
        },
        methods: {
            clickLink(_info) {
                // 同人和主播在没有配置链接的时候，弹出配置在author上的提示语
                if (_info.link) {
                    window.location.href = _info.link;
                    Util.trackGA('点击', this.lan + ':粉丝团按钮', this.lan + ':粉丝团按钮');
                } else if (_info.keyword == 'fan_btn' && _info.link == '') {
                    Util.trackGA('点击', this.lan + ':同人作品按钮', this.lan + ':同人作品按钮');
                    this.alertText = _info.author;
                    this.showPopup = true;
                } else if (_info.keyword == 'streamer_btn' && _info.link == '') {
                    Util.trackGA('点击', this.lan + ':甜蜜主播按钮', this.lan + ':甜蜜主播按钮');
                    this.alertText = _info.author;
                    this.showPopup = true;
                } else {
                    this.showQrPopup = !this.showQrPopup;
                    Util.trackGA('点击', this.lan + ':微信按钮', this.lan + ':微信按钮');
                }
            },
            closePop() {
                this.showQrPopup = !this.showQrPopup;
            },
            closeAlertPop() {
                this.showPopup = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/index/link-tab.vue